import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEuroSign } from '@fortawesome/free-solid-svg-icons';
import { faDollarSign } from '@fortawesome/free-solid-svg-icons';

const CurrencyIcon = ({currency}) => {
    switch (currency) {
        case 'EUR':
            return <FontAwesomeIcon icon={faEuroSign} />;
        case 'USD':
            return <FontAwesomeIcon icon={faDollarSign} />;
        default:
    }

    return currency;
};

CurrencyIcon.propTypes = {
    currency: PropTypes.string
};

export default CurrencyIcon;



// WEBPACK FOOTER //
// ./src/components/formatters/currency-icon.js